import { useCallback, useEffect, useState } from "react";
import { LoadingSkeleton } from "./Skeleton";
import FetchData from "../../../../Helper/HttpRequestHelper";
import { Link } from "react-router-dom";
import { toHumanDateTime, toRupiah } from "../../../../Helper/StringHelper";
import { Button, Modal } from "react-bootstrap";

const PublicationComponent = (props) => {
  const [loading, setLoading] = useState(true);
  const [transactions, setTransactions] = useState([]);
  const [transaction, setTransaction] = useState({});
  const [showDetail, setShowDetail] = useState(false);
  const { subType } = props;

  const fethcData = useCallback(async () => {
    setLoading(true);
    const response = await FetchData("member/transactions/publication", {
      payment_status: subType,
    });
    if (response.status_code === 200) {
      setTransactions(response.data.data);
      setLoading(false);
    }
  }, [subType]);

  useEffect(() => {
    fethcData();
  }, [subType, fethcData]);

  const onShowDetail = (transaction) => {
    setShowDetail(true);
    setTransaction(transaction);
  };

  const onDetailClose = () => {
    setShowDetail(false);
    setTransaction({});
  };

  return (
    <>
      {loading && <LoadingSkeleton />}
      {!loading && transactions.length === 0 && (
        <div className="alert alert-info">Transaksi tidak ditemukan</div>
      )}
      {transactions.length > 0 &&
        transactions.map((transaction, index) => {
          return (
            <div className="card mb-4 card-transaction" key={index}>
              <div className="card-body">
                <div className="card-title d-flex justify-content-between align-items-center">
                  <div className="invoice-label">
                    No. {transaction.invoice_number}
                  </div>
                  <div>
                    <div
                      className={`label-status ${
                        transaction.payment_status === "PENDING"
                          ? "bg-warning"
                          : transaction.payment_status === `EXPIRED` ||
                            transaction.payment_status === "CANCELED"
                          ? "bg-danger"
                          : "bg-success text-white"
                      } rounded`}
                    >
                      {transaction.payment_status}
                    </div>
                  </div>
                </div>
                <div className="card-text">
                  <dl className="d-flex">
                    <dt className="col-4 col-md-3">Deskripsi</dt>
                    <dd>{transaction.description}</dd>
                  </dl>
                  {transaction?.article && (
                    <dl className="d-flex">
                      <dt className="col-4 col-md-3">Data Stories</dt>
                      <dd>
                        {" "}
                        <Link to={transaction.article.url} target="_blank">
                          {transaction.article.nama}
                        </Link>
                      </dd>
                    </dl>
                  )}
                  <dl className="d-flex">
                    <dt className="col-4 col-md-3">Durasi</dt>
                    <dd>
                      {toHumanDateTime(transaction.subscription_start, true)} -{" "}
                      {toHumanDateTime(transaction.subscription_end, true)}
                    </dd>
                  </dl>
                  {transaction.payment_status === "PENDING" && (
                    <dl className="d-flex">
                      <dt className="col-4 col-md-3">Bayar Sebelum</dt>
                      <dd>{toHumanDateTime(transaction.invoice_expire_at)}</dd>
                    </dl>
                  )}
                  <dl className="d-flex">
                    <dt className="col-4 col-md-3">Harga Item</dt>
                    <dd>{toRupiah(transaction.item_price)}</dd>
                  </dl>
                  {transaction.voucher_code && (
                    <dl className="d-flex">
                      <dt className="col-4 col-md-3">Potongan Voucher</dt>
                      <dd>{toRupiah(transaction.voucher_amount)}</dd>
                    </dl>
                  )}
                  <dl className="d-flex">
                    <dt className="col-4 col-md-3">Jumlah Tagihan</dt>
                    <dd>{toRupiah(transaction.total_price)}</dd>
                  </dl>
                </div>
                <div className="card-footer d-flex justify-content-between align-items-center">
                  <Link
                    to={`${process.env.REACT_APP_API_URL}download/invoice/publication/${transaction.invoice_number}`}
                  >
                    Download Invoice
                  </Link>
                  <div>
                    <button
                      className="btn btn-primary btn-sm"
                      to={"/"}
                      onClick={() => onShowDetail(transaction)}
                    >
                      Detail
                    </button>
                    {transaction.payment_status === "PENDING" && (
                      <Link
                        className="btn btn-success btn-sm ms-3"
                        to={transaction.invoice_url}
                      >
                        Bayar Sekarang
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      <DetailModal
        show={showDetail}
        handleClose={onDetailClose}
        transaction={transaction}
      />
    </>
  );
};

const DetailModal = ({ show, handleClose, transaction }) => {
  return (
    <Modal show={show} onHide={handleClose} size="lg" backdrop="static">
      <Modal.Header>
        <Modal.Title className="text-primary">
          {transaction?.invoice_number}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        <div className="card card-transaction">
          <div className="card-body">
            <div className="card-text">
              <dl className="d-flex">
                <dt className="col-5 col-md-3">Deskripsi</dt>
                <dd>{transaction?.description}</dd>
              </dl>
              {transaction?.article && (
                <dl className="d-flex">
                  <dt className="col-5 col-md-3">Data</dt>
                  <dd>
                    {" "}
                    <Link to={transaction?.article.url} target="_blank">
                      {transaction.article.nama}
                    </Link>
                  </dd>
                </dl>
              )}
              <dl className="d-flex">
                <dt className="col-5 col-md-3">Durasi</dt>
                <dd>
                  {toHumanDateTime(transaction?.subscription_start, true)} -{" "}
                  {toHumanDateTime(transaction?.subscription_end, true)}
                </dd>
              </dl>
              {transaction.payment_status === "PENDING" && (
                <dl className="d-flex">
                  <dt className="col-5 col-md-3">Bayar Sebelum</dt>
                  <dd className="text-danger">
                    {toHumanDateTime(transaction?.invoice_expire_at)}
                  </dd>
                </dl>
              )}
              <dl className="d-flex">
                <dt className="col-5 col-md-3">Harga Item</dt>
                <dd>{toRupiah(transaction?.item_price)}</dd>
              </dl>
              {transaction.voucher_code && (
                <dl className="d-flex">
                  <dt className="col-5 col-md-3">Potongan Voucher</dt>
                  <dd>{toRupiah(transaction?.voucher_amount)}</dd>
                </dl>
              )}
              <dl className="d-flex">
                <dt className="col-5 col-md-3">Jumlah Tagihan</dt>
                <dd>{toRupiah(transaction?.total_price)}</dd>
              </dl>
              <dl className="d-flex">
                <dt className="col-5 col-md-3 d-block d-md-none">
                  Status <br /> Pembayaran
                </dt>
                <dt className="col-5 col-md-3 d-none d-md-block">
                  Status Pembayaran
                </dt>
                <dd>
                  {" "}
                  <span
                    className={`label-status ${
                      transaction?.payment_status === "PENDING"
                        ? "bg-warning text-white"
                        : transaction?.payment_status === `EXPIRED`
                        ? "bg-danger"
                        : "bg-success text-white"
                    } rounded`}
                  >
                    {transaction?.payment_status}
                  </span>
                </dd>
              </dl>
              {transaction?.payment_status === "PAID" && (
                <>
                  <dl className="d-flex">
                    <dt className="col-5 col-md-3">Jumlah Dibayar</dt>
                    <dd>{toRupiah(transaction.paid_amount)}</dd>
                  </dl>
                  <dl className="d-flex">
                    <dt className="col-5 col-md-3">Tanggal Pembayaran</dt>
                    <dd>{toHumanDateTime(transaction.paid_at)}</dd>
                  </dl>
                  <dl className="d-flex">
                    <dt className="col-5 col-md-3">Metode Pembayaran</dt>
                    <dd>
                      {transaction?.payment_method} (
                      {transaction?.payment_channel})
                    </dd>
                  </dl>
                </>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} className="btn-sm">
          Tutup
        </Button>
        {transaction?.payment_status === "PENDING" && (
          <Link to={transaction.invoice_url} className="btn btn-success btn-sm">
            Bayar Sekarang
          </Link>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default PublicationComponent;
